import { render, staticRenderFns } from "./BureauDetailsActivity.vue?vue&type=template&id=414bd3de&scoped=true&"
import script from "./BureauDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./BureauDetailsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414bd3de",
  null
  
)

export default component.exports